import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      textAlign: 'center',
      color: theme.palette.primary.main,
      marginTop: 0,
    },
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    border: '1px solid #999',
    '& th': {
      border: '1px solid #999',
      cursor: 'pointer',
      width: '33.33%',
      '&:nth-child(1)': {
        backgroundColor: '#ffe634',
      },
      '&:nth-child(2)': {
        backgroundColor: '#97d1ea',
      },
      '&:nth-child(3)': {
        backgroundColor: '#7ce479',
      },
    },
    '& td': {
      borderLeft: '1px solid #999',
      borderRight: '1px solid #999',
      width: '33.33%',
      textAlign: 'center',
      height: '1.5em',
      cursor: 'pointer',
      '&:nth-child(1)': {
        backgroundColor: '#fff9cc',
      },
      '&:nth-child(2)': {
        backgroundColor: '#c4e6f5',
      },
      '&:nth-child(3)': {
        backgroundColor: '#bcf3bb',
      },
      '& button': {
        marginBottom: 0,
      },
    },
    '& button': {
      width: '95%',
      margin: '5px 0 5px',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '1.25em',
    marginTop: 0,
    '& span': {
      background: '#f6eff7',
      display: 'inline-block',
      padding: '0.25em 2em',
      borderRadius: '1em',
      color: theme.palette.secondary.main,
    },
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

const defaultTable = [
  [ false, false, false, false, false, false, false, false, false, false, ],
  [ false, false, false, false, false, false, false, false, false, false, ],
  [ false, false, false, false, false, false, false, false, false, false, ],
];

function OrderThem(props) {
  const classes = useStyles();
  const [ showTrans, setShowTrans ] = useState([ false, false, false ]);
  const [ words, setWords ] = useState([]);
  const [ table, setTable ] = useState(defaultTable);
  const [ finished, setFinished ] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  const add = (colNo) => {
    action();
    if (getColLen(colNo) > 9) return;
    const newTable = [[ ...table[0]],[ ...table[1]],[ ...table[2]]];
    const idx = newTable[colNo].reduce((sum, current) => current ? sum + 1 : sum, 0);
    const newWords = [ ...words];
    const word = newWords.shift();
    if (word === undefined) return;
    newTable[colNo][idx] = word;
    setTable(newTable);
    setWords(newWords);
  }

  const init = () => {
    startStats(type);
    setWords([ ...shuffle(exercise.words) ]);
    setTable(defaultTable);
    setFinished(false);
  }

  const getColLen = colNo => {
    return table[colNo].reduce((result, current) => current ? result + 1 : result, 0);
  }

   const getText = (group, idx) => {
    return table[group][idx] ? table[group][idx].text : '';
  }

  const checkAnswer = () => {
    if (table[0].length + table[1].length  + table[2].length === 0 ) return;
    action();
    let wrongWords = [];
    const newTable = [[ ...table[0]],[ ...table[1]],[ ...table[2]]];
    [0, 1, 2].forEach(group => {
      const arr = newTable[group];
      const wrong = arr.filter(word => word && word.group !== (group + 1));
      if (wrong.length) {
        wrongWords = [ ...wrongWords, ...wrong ];
        newTable[group] = arr.filter(word => word && word.group === (group + 1));
      }
    });
    if (wrongWords.length) {
      setWords([ ...words, ...wrongWords ]);
      setTable(newTable);
      failure();
    } else {
      success();
    }
  }

  const success = () => {
    if (words.length === 0) {
      finish();
    } else {
      props.media.success();
    }
  }

  const failure = () => {
    props.media.failure();
  }

  const finish = () => {
    props.media.finish();
    finishExercise();
    setFinished(true);
  }

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Dodaj wyraz do wybranej kategorii</h3>
        <p className={classes.title}>
          {!finished &&<span>{words.length  > 0 ? words[0].text : 'Sprawdź zadanie'}</span>}
          {finished &&<span>Koniec</span>}
        </p>
        <table className={classes.table}>
          <thead>
            <tr>
              {!showTrans[0] && <th onClick={() => setShowTrans([ true,  false, false])}>{exercise.group1}</th>}
              { showTrans[0] && <th onClick={() => setShowTrans([ false, false, false])}>{exercise.translation1}</th>}
              {!showTrans[1] && <th onClick={() => setShowTrans([ false, true,  false])}>{exercise.group2}</th>}
              { showTrans[1] && <th onClick={() => setShowTrans([ false, false, false])}>{exercise.translation2}</th>}
              {!showTrans[2] && <th onClick={() => setShowTrans([ false, false, true ])}>{exercise.group3}</th>}
              { showTrans[2] && <th onClick={() => setShowTrans([ false, false, false])}>{exercise.translation3}</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><Button color="primary" onClick={(() => add(0))}><AddIcon /></Button></td>
              <td><Button color="primary" onClick={(() => add(1))}><AddIcon /></Button></td>
              <td><Button color="primary" onClick={(() => add(2))}><AddIcon /></Button></td>
            </tr>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(idx => <tr key={idx}>
              <td onClick={(() => add(0))}>{getText(0, idx)}</td>
              <td onClick={(() => add(1))}>{getText(1, idx)}</td>
              <td onClick={(() => add(2))}>{getText(2, idx)}</td>
            </tr>)}
          </tbody>
        </table>
        <div className={classes.action}>
          {!finished &&<Button variant="outlined" color="secondary" onClick={checkAnswer}>Sprawdź</Button>}
          {finished &&<Button variant="outlined" color="primary" onClick={init}>Wyczyść</Button>}
          {finished &&<Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps)(OrderThem);